import { render, staticRenderFns } from "./send-email.vue?vue&type=template&id=a0295950&scoped=true"
import script from "./send-email.vue?vue&type=script&lang=js"
export * from "./send-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0295950",
  null
  
)

export default component.exports